import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import PageHeading from "../components/page-heading"
import Button from "../components/button"
import Gallery from "../components/gallery"
import { GatsbyImage } from "gatsby-plugin-image"
import { normalizePath } from "../utils/get-url-path"
import CareersForm from "../components/careers-form"
import { gradiMeta } from "../utils/seo"
import Seo from "gatsby-plugin-wpgraphql-seo"

const Careers = ({ data, pageContext: { currentBrand, id }, location }) => {
  const title = "Careers"
  const isAusSite = data.site.siteMetadata.siteUrl.includes(".com.au")
  const careers = data.wpBrand.brand.careers
  console.log({ careers })
  const { careersInfo, images, customEmbed } = careers
  const meta = gradiMeta({
    seo: data.wpBrand.seo,
    location,
    title,
    currentBrand,
  })
  return (
    <Layout currentBrand={currentBrand} location={location}>
      <Seo post={data.wpBrand} meta={meta} />
      <PageHeading>{title}</PageHeading>
      {isAusSite ? (
        <>
          <div className="flex flex-col gap-20">
            <div className="grid grid-cols-1 gap-10 md:gap-0 md:grid-cols-2">
              <div className="flex md:pr-24 flex-col gap-10 justify-space-between order-2 md:order-1">
                <div>
                  <div className="whitespace-pre-wrap">{careersInfo}</div>
                  <div className="uppercase h-10"></div>
                  <div dangerouslySetInnerHTML={{ __html: customEmbed }} />
                </div>
              </div>
              <div className="order-1 md:order-2">
                <Gallery gallery={images} />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-col gap-20">
            <div className="flex flex-col gap-10 place-items-center order-2 md:order-1">
              <div className="uppercase w-full">
                <div className="whitespace-pre-wrap"></div>
                <div className="h-10"></div>
                <CareersForm />
              </div>
            </div>
          </div>
        </>
      )}
    </Layout>
  )
}

export const data = graphql`
  query brandCareers($brandNames: [String] = "") {
    site {
      siteMetadata {
        siteUrl
      }
    }
    wpBrand(brand: { brandStyle: { in: $brandNames } }) {
      nodeType
      title
      uri
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphUrl
        canonical
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
      brand {
        brandStyle
        careers {
          careersInfo
          images {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 1.5)
              }
            }
          }
          customEmbed
        }
        menuLinks {
          linkUrl {
            url
            title
            target
          }
        }
        menu {
          localFile {
            publicURL
          }
        }
        banners {
          type
          buttonText
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(aspectRatio: 1, layout: FULL_WIDTH)
              }
            }
          }
          teaser
          title
          gallery {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, aspectRatio: 1)
              }
            }
          }
          gradiBannerColor
          mercatoBannerColour
          zeroBannerColour
          pageUrl {
            url
            title
          }
        }
      }
    }
    allWpLocation(
      filter: { location: { brand: { in: $brandNames } } }
      sort: { location: { order: ASC } }
    ) {
      nodes {
        title
        nodeType
        uri
        slug
        seo {
          title
          metaDesc
          focuskw
          metaKeywords
          metaRobotsNoindex
          metaRobotsNofollow
          opengraphTitle
          opengraphDescription
          opengraphUrl
          canonical
          opengraphImage {
            altText
            sourceUrl
            srcSet
          }
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            srcSet
          }
          cornerstone
          schema {
            articleType
            pageType
            raw
          }
        }
        location {
          region
          order
          brand
          location
          links {
            booking
          }
        }
      }
    }
  }
`

export default Careers
